<form [formGroup]="parentFormGroup">
  <h3 class="sub-section-title">Rules</h3>
  <button type="button" mat-button (click)="addNewRule()" class="add-rule-button">
    <mat-icon>add</mat-icon> Add Rule
  </button>
  <div class="container-wrap">
    <div formArrayName="rules">
      @for (rule of sectionConfig.filter.rules; track rule; let i = $index) {
        <div class="rule">
          @if (getRulesFormGroup(i); as ruleGroup) {
            <div>
              <div class="row-wrap">
                <span class="label">Include Categories</span>
                <div [formGroup]="ruleGroup" class="item">
                  <categories-selector [parentFormGroup]="ruleGroup" controlName="includeCategories"
                    placeholderText="Please select Categories to include"></categories-selector>
                </div>
              </div>
              <div class="row-wrap">
                <span class="label">Exclude Categories</span>
                <div [formGroup]="ruleGroup" class="item">
                  <categories-selector [parentFormGroup]="ruleGroup" controlName="excludeCategories"
                    placeholderText="Please select Categories to exclude"></categories-selector>
                </div>
              </div>
              <div class="row-wrap">
                <span class="label">Services</span>
                <div [formGroup]="ruleGroup" class="item">
                  <service-selector [parentFormGroup]="ruleGroup" controlName="services"
                    placeholderText="Please select Services"></service-selector>
                </div>
              </div>
              <div class="controls">
                <button type="button" mat-raised-button color="primary" (click)="deleteRule(i)">
                  <mat-icon>delete_outline</mat-icon> Delete Rule
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
    @if (!sectionConfig.filter.rules?.length) {
      <div class="note">There are no Rules for this section.</div>
    }
  </div>
</form>
